// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Database Manager API
 * API to orchestra resources
 *
 * The version of the OpenAPI document: 2.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface AdminApiV2TypesCondition
 */
export interface AdminApiV2TypesCondition {
  /**
   *
   * @type {string}
   * @memberof AdminApiV2TypesCondition
   */
  message?: string;
  /**
   *
   * @type {string}
   * @memberof AdminApiV2TypesCondition
   */
  name?: string;
  /**
   *
   * @type {string}
   * @memberof AdminApiV2TypesCondition
   */
  reason?: string;
  /**
   *
   * @type {number}
   * @memberof AdminApiV2TypesCondition
   */
  secondsSinceTransition?: number;
  /**
   *
   * @type {number}
   * @memberof AdminApiV2TypesCondition
   */
  secondsSinceUpdate?: number;
  /**
   *
   * @type {boolean}
   * @memberof AdminApiV2TypesCondition
   */
  value?: boolean | null;
}

/**
 * Check if a given object implements the AdminApiV2TypesCondition interface.
 */
export function instanceOfAdminApiV2TypesCondition(
  value: object,
): value is AdminApiV2TypesCondition {
  return true;
}

export function AdminApiV2TypesConditionFromJSON(
  json: any,
): AdminApiV2TypesCondition {
  return AdminApiV2TypesConditionFromJSONTyped(json, false);
}

export function AdminApiV2TypesConditionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AdminApiV2TypesCondition {
  if (json == null) {
    return json;
  }
  return {
    message: json['Message'] == null ? undefined : json['Message'],
    name: json['Name'] == null ? undefined : json['Name'],
    reason: json['Reason'] == null ? undefined : json['Reason'],
    secondsSinceTransition:
      json['SecondsSinceTransition'] == null
        ? undefined
        : json['SecondsSinceTransition'],
    secondsSinceUpdate:
      json['SecondsSinceUpdate'] == null
        ? undefined
        : json['SecondsSinceUpdate'],
    value: json['Value'] == null ? undefined : json['Value'],
  };
}

export function AdminApiV2TypesConditionToJSON(
  json: any,
): AdminApiV2TypesCondition {
  return AdminApiV2TypesConditionToJSONTyped(json, false);
}

export function AdminApiV2TypesConditionToJSONTyped(
  value?: AdminApiV2TypesCondition | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    Message: value['message'],
    Name: value['name'],
    Reason: value['reason'],
    SecondsSinceTransition: value['secondsSinceTransition'],
    SecondsSinceUpdate: value['secondsSinceUpdate'],
    Value: value['value'],
  };
}
